













































































//@ts-nocheck

//@ts-ignore
import poa_series from '@/mixins/axios/poa_series'

//@ts-ignore
import poa_techo_secretarias from '@/mixins/axios/poa_techo_secretarias'

//@ts-ignore
import poa_techo_capitulos from '@/mixins/axios/poa_techo_capitulos'

import { Component, Vue } from 'vue-property-decorator';
@Component({
 components: {
   
  },
  mixins:[poa_series,poa_techo_secretarias,poa_techo_capitulos],
   data() {
    return {
       poa_seriesdata:[] as any,
       techos_secretaria_series:[] as any,
       techos_capitulos_series:[] as any,
       serie:0,
       element_v:true as any
    }
    },
    methods:
    {
ValorAsignadoVerify(index,valor){

if(this.techos_capitulos_series[index].usado>this.techos_capitulos_series[index].monto){
    this.techos_capitulos_series[index].monto=this.techos_capitulos_series[index].usado;
}
},

async saveData(){
 this.$root.$emit('loading', true);
let data2={

//techos_capitulo:this.techos_capitulos_series,
techos_secretaria:this.techos_secretaria_series,


}
        let data= await this.UPDATE_DATA_CAPITULOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       
                        
                    
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar los techos capitulos serie, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });


},
async getDataCapitulosSerie() {
  
 this.$root.$emit('loading', true);

let data={
id:this.serie
};

let data2= await this.GET_POA_TECHO_CAPITULOS_SERIE(data).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       
                        
this.techos_capitulos_series=response;
 for (let index = 0; index < this.techos_capitulos_series.length; index++) {
                            if(this.techos_capitulos_series[index].usado==null){
                                this.techos_capitulos_series[index].usado=0;
                            }
                            
                            
                        }
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar los techos capitulos serie, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
async getDataSerie() {
  
 this.$root.$emit('loading', true);

let data2={
id:this.serie,
secretaria:5
};

let data= await this.GET_POA_DEPARTAMENTO_TECHO_CAPITULOS_SECRETARIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.techos_secretaria_series=response;
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las series, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
techoDisponible(ind_sec,inde_dep,ind_techo){
     let idcap=this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo]['poa_capitulos_conacs_id'];
     //this.techos_capitulos_series[index].usado=asignados[idcap];
     const index = this.techos_capitulos_series.findIndex(el => el['poa_capitulos_conacs_id'] === idcap);

     if(this.techos_capitulos_series[index].monto>this.techos_capitulos_series[index].usado){
         return true;
     }else{
         return false;
     }
},
techoDisponibleNumber(ind_sec,inde_dep,ind_techo){
     let idcap=this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo]['poa_capitulos_conacs_id'];
     //this.techos_capitulos_series[index].usado=asignados[idcap];
     const index = this.techos_capitulos_series.findIndex(el => el['poa_capitulos_conacs_id'] === idcap);

     if(this.techos_capitulos_series[index].monto>this.techos_capitulos_series[index].usado){
         return [Number(this.techos_capitulos_series[index].monto)-Number(this.techos_capitulos_series[index].usado),0];
     }else{
         return [0,this.techos_capitulos_series[index]];
     }
},
asignUsadoCapitulo(ind_sec){
var total_capitulo=[];
this.techos_secretaria_series[ind_sec]['departamentos'].forEach(departamentos => {
    
                departamentos['techos_departamentos'].forEach(techos_depa => {
                    if(total_capitulo.hasOwnProperty(techos_depa.poa_capitulos_conacs_id)){
                        total_capitulo[techos_depa.poa_capitulos_conacs_id]=Number(total_capitulo[techos_depa.poa_capitulos_conacs_id])+Number(techos_depa.monto);
                    }else{
                        total_capitulo[techos_depa.poa_capitulos_conacs_id]=Number(techos_depa.monto);
                    }
                    //total_capitulo[element.poa_capitulos_conacs_id]=
            
                });
       

});
return total_capitulo;

},

maptosecretaria(ind_sec,inde_dep,ind_techo,valor){
this.element_v=false;
var total=0;
var total_capitulo=[];
this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'].forEach(element => {
    total=Number(total)+Number(element.monto);
    //if(element.poa_capitulos_conacs_id==)
    //total_capitulo[element.poa_capitulos_conacs_id]=
});
console.log(total)
    if(Number(total)>Number(this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep].monto)){

    console.log('tot')

    this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'].forEach(element => {
        console.log(element)
        element.color_activo='red';
          this.element_v=true;
    });
    }else if(Number(total)<Number(this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep].monto)){
           console.log('tot2')
        this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'].forEach(element => {
        element.color_activo='#467ae4';
          this.element_v=true;
    })
    } else{

        console.log('tot2')
        this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'].forEach(element => {
        element.color_activo='green';
          this.element_v=true;
    });
  
}



},

OLD_maptosecretaria(ind_sec,inde_dep,ind_techo,valor){
//alert(valor);






//poa_capitulos_conacs_id--------------------------asignacion de valor usado a techo capitulo-----------------------------

console.log(this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo]['poa_capitulos_conacs_id'])
console.log(this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo])
console.log(this.techos_capitulos_series)
const index = this.techos_capitulos_series.findIndex(el => el['poa_capitulos_conacs_id'] === this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo]['poa_capitulos_conacs_id']);
 let asignados=this.asignUsadoCapitulo(ind_sec);
 console.log(index)
 console.log( this.techos_capitulos_series[index])
 console.log(asignados)
 let idcap=this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo]['poa_capitulos_conacs_id'];
 console.log(idcap)
 this.techos_capitulos_series[index].usado=asignados[idcap];

/////////////////////------------------------------------------------------------------------------------------------



////--------------------------------verifica asignacion no excedente-------------------
let usado=0;
let valores=this.techoDisponibleNumber(ind_sec,inde_dep,ind_techo);
let valor_restante=0;
let valor_maximo=0;
if(valores[0]==0){
    console.log('valores----')
    console.log(valores);
     console.log('valores----')
    //obtengo valor en exceso
valor_restante=valores[1].usado-valores[1].monto;
//obtengo el valor maximo a asignar 
valor_maximo=valor-valor_restante;
//asigno valor maximo para que la cantidad no sea en exceso
this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'][ind_techo].monto=valor_maximo;
 this.techos_capitulos_series[index].usado=this.techos_capitulos_series[index].monto;

}
//////////--------------------------------------------------------------------------

////////////----------------asignacion de totales por secretaria y departamento-----------------------

var total=0;
var total_capitulo=[];
this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['techos_departamentos'].forEach(element => {
    total=Number(total)+Number(element.monto);
    //if(element.poa_capitulos_conacs_id==)
    //total_capitulo[element.poa_capitulos_conacs_id]=
});

this.techos_secretaria_series[ind_sec]['departamentos'][inde_dep]['total']=total;



var total_2=0;
this.techos_secretaria_series[ind_sec]['departamentos'].forEach(element => {
    total_2=Number(total_2)+Number(element.total);
});
this.techos_secretaria_series[ind_sec]['monto']=total_2;



////-------------------------------------------------------------------------------------------------


},
async getData() {
  
 this.$root.$emit('loading', true);

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_POA_SERIES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.poa_seriesdata=response;
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las series, refresque la pagina");

                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},


    },
    mounted(){
    this.getData(); 
    }

}
)
export default class homepathc extends Vue {}

